import React from "react"
import { CircularProgress } from "@material-ui/core"

export const TextInput = ({	className, type,	label,	value,	onChange,	placeholder = "" }) => {
	return (
		<div className={className + " " + "textInput__container"}>
			<input
				type={type || "text"}
				className="textInput__input"
				value={value}
				onChange={onChange}
        placeholder={placeholder}
        required
			/>
			<label htmlFor="" className="textInput__label">
				{label}
			</label>
		</div>
	)
}

export const InputGroup = ({ label, type, id, value, setValue, placeholder, required, className }) => {
  return (
    <div className={`inputGroup ${className || ""}`}>
      <label htmlFor={id} className="label">{label}</label>
      <input 
        type={type || "text"} 
        className="input"
        id={id}
        value={value}
        required={required || false}
        placeholder={placeholder || ""}
        onChange={e => setValue(e.target.value)}
      />
    </div>
  )
}

export const Loading = ({title, size}) => (
  <div className="loading">
    <CircularProgress style={{fontSize : size || "unset"}} />
    <p style={{fontSize: size || "unset"}} className="loading__text">{title}</p>
  </div>
)
